import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-left-up-icon',
  templateUrl: './design-anchor-left-up.component.html'
})
export class DesignAnchorLeftUpComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
